import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { AgentModel, AgentToolsetSettings } from '../../../../../../gamma-api';
import { defaultApi } from '../../../../../apis';
import IbButton from '../../../../../components/common/IbButton';
import IbIcon from '../../../../../components/common/IbIcon';
import IbTypography from '../../../../../components/common/IbTypography';
import { getTranslateFunc } from '../../../../../utils/stringUtil';
import IbTooltip from '../../../../../components/common/IbTooltip';
import IbDivider from '../../../../../components/common/IbDivider';
import { getAgentPath } from '../../../../../utils/pathUtils';

import { ACTION_CLASS_NAME, FOOTER_CLASS_NAME, SECTION_CLASS_NAME } from './const';
import BaseToolsetListItem from './BaseToolsetListItem';

import { IToolsetListItemProps } from './index';

const AgentToolset: React.FC<IToolsetListItemProps> = ({ toolset, onSetup, onDelete, onToolsetStateChange }) => {
  const { push } = useHistory();
  const [loading, setLoading] = useState(false);
  const [agent, setAgent] = useState<AgentModel>();

  const settings = toolset.settings as AgentToolsetSettings;
  const translate = getTranslateFunc('Agent: Toolset: List: Item: Agent:');

  const fetchAgent = async () => {
    try {
      setLoading(true);
      const response = await defaultApi.getOneAgent(settings.agent_id);
      setAgent(response.data);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => void fetchAgent(), [settings.agent_id]);

  const renderAction = () => {
    if (!agent) return;
    const onAgentToolsetButtonClick = () =>
      push(getAgentPath(agent.settings.interface.type, agent.folder_id, agent.agent_id));
    return (
      <IbButton
        className={ACTION_CLASS_NAME}
        icon={<IbIcon iconName="efferent-four" />}
        type="icon"
        onClick={onAgentToolsetButtonClick}
      />
    );
  };

  const renderFooter = () => {
    return (
      <>
        <IbDivider />
        <div className={FOOTER_CLASS_NAME}>
          <div className={SECTION_CLASS_NAME}>
            <IbTypography.Paragraph disabled>{translate('Instruction')}</IbTypography.Paragraph>
            <IbTooltip title={settings.call_agent_tool_settings.tool_description}>
              <IbTypography.Paragraph ellipsis>
                {settings.call_agent_tool_settings.tool_description}
              </IbTypography.Paragraph>
            </IbTooltip>
          </div>
        </div>
      </>
    );
  };

  return (
    <BaseToolsetListItem
      action={renderAction()}
      footer={renderFooter()}
      loading={loading}
      name={agent?.name}
      toolCount={1}
      toolset={toolset}
      onDelete={onDelete}
      onSetup={onSetup}
      onToolsetStateChange={onToolsetStateChange}
    />
  );
};

export default AgentToolset;
